<template>
  <div class="form">
    <div class="header">
      <div @click="back()">
        <back />
      </div>
      <h3>Pekerjaan</h3>
    </div>

    <!-- <div class="nav-top">
      <div class="title">TUGAS KERJA</div>
      <div
        v-if="$route.query.editable != 0"
        class="save"
        @click="simpanPekerjaan"
      >
        <save />
      </div>
    </div> -->

    <div class="body">
      <div class="skeleton-wrapper" v-show="loading">
        <div class="skeleton label"></div>
        <div class="skeleton input"></div>

        <div class="skeleton label"></div>
        <div class="skeleton textarea"></div>

        <div class="skeleton label"></div>
        <div class="skeleton input"></div>

        <div class="skeleton label"></div>
        <div class="skeleton input"></div>

        <div class="skeleton input"></div>
      </div>

      <div class="card" v-show="!loading">
        <form @submit.prevent="simpanPekerjaan">
          <div class="form-group">
            <label for="">Nama Pekerjaan</label>
            <input type="text" v-model="pekerjaan.nama" />
          </div>
          <div class="form-group" v-if="$user.access == 'ADMIN'">
            <label for="">Untuk PIC</label>
            <select v-model="pekerjaan.id_user">
              <option></option>
              <option
                v-for="(item, index) in user"
                :key="index"
                :value="item.id"
              >
                {{ item.nama }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Keterangan</label>
            <textarea rows="7" v-model="pekerjaan.keterangan"></textarea>
          </div>
          <div class="form-group tgl-target">
            <label for="">Tgl Target</label>
            <datepicker v-model="pekerjaan.tgl_target"></datepicker>
          </div>
          <div class="form-group">
            <label for="">Gambar</label>
            <p style="text-align: center">
              <img :src="pekerjaan.gambar" width="50%" />
            </p>

            <div class="btn-grid">
              <span class="camera" @click="openCamera">
                <camera />
                Camera
              </span>
              <span class="gallery">
                <Gallery />
                Gallery
                <input type="file" accept="image/jpg" @change="inputFile" />
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="">Status</label>
            <select v-model="pekerjaan.status">
              <option value="TODO">TODO</option>
              <option value="IN_PROGRESS">IN PROGRESS</option>
              <option value="COMPLETE">COMPLETE</option>
              <option value="CANCEL">CANCEL</option>
            </select>
          </div>
          <button type="submit" class="btn" :disabled="loadingSimpan">
            {{ loadingSimpan ? "MENYIMPAN..." : "SIMPAN" }}
          </button>
        </form>
      </div>

      <div
        class="progress"
        v-if="
          $route.params.id > 0 &&
          (pekerjaan.status == 'IN_PROGRESS' || pekerjaan.status == 'COMPLETE')
        "
      >
        <p>Progress</p>
        <div class="progress-list">
          <ul v-if="progress.length > 0">
            <li
              v-for="(item, index) in progress"
              :key="index"
              @click="edit(item)"
            >
              <small>{{
                moment(item.created_at).format("DD MMM YY HH:mm")
              }}</small>
              <p>{{ item.keterangan }}</p>
            </li>
          </ul>
        </div>
        <div class="progress-list" v-if="!editing && !addProgress">
          <button
            v-if="$route.query.editable != 0"
            type="button"
            class="btn-progress"
            @click="tambahProgress()"
          >
            TAMBAH PROGRESS
          </button>
        </div>

        <div class="progress-form" v-if="addProgress" style="margin-top: 30px">
          <form>
            <input type="hidden" v-model="pekerjaanDetail.id" />
            <div class="form-group">
              <label for="">Keterangan</label>
              <textarea
                rows="3"
                v-model="pekerjaanDetail.keterangan"
              ></textarea>
            </div>
          </form>

          <div class="btn-grid">
            <button
              type="button"
              class="btn-progress"
              @click="updateProgress()"
            >
              {{ loadingDetail ? "MENYIMPAN..." : "SIMPAN" }}
            </button>
            <button
              type="button"
              class="btn-progress btn-batal"
              @click="hideForm()"
            >
              BATAL
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="overlay-loading" v-show="loadingGambar">
      <Loading />
      <p>Memproses gambar...</p>
    </div>
  </div>
</template>

<script>
import Save from "./icons/Save.vue";
import Back from "./icons/Back.vue";
import Gallery from "./icons/Gallery.vue";
import Camera from "./icons/Camera.vue";
import Loading from "./icons/Loading.vue";

import moment from "moment";
import axios from "axios";
import * as api from "../api/Api";

import Datepicker from "vuejs-datepicker";

export default {
  name: "Home",
  components: {
    Save,
    Back,
    Datepicker,
    Gallery,
    Camera,
    Loading,
  },
  data() {
    return {
      addProgress: false,
      editing: false,
      pekerjaan: {
        status: "TODO",
        gambar: "",
      },
      pekerjaanDetail: {},
      progress: [],
      loading: false,
      file: null,
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
      },

      loadingSimpan: false,
      loadingDetail: false,
      user: [],

      modalOpen: false,
      showPhoto: false,
      video: null,
      canvas: null,
      photo: null,
      localStream: null,
      streaming: false,
      dataImage: null,

      loadingGambar: false,
    };
  },
  methods: {
    moment,
    back() {
      setTimeout(() => {
        this.$router.back();
      }, 150);
    },
    tambahProgress() {
      setTimeout(() => {
        this.addProgress = true;
        this.pekerjaanDetail = {
          status: "TODO",
        };
      }, 150);
    },
    loadData(id) {
      api
        .get("/v1/kendali_kerja/pekerjaanController/get?id=" + id)
        .then((r) => {
          this.pekerjaan = r.data.pekerjaan;
          this.progress = r.data.pekerjaan_detail;

          this.dateRange = {
            startDate: this.pekerjaan.tgl_target,
          };
        });
    },
    inputFile(e) {
      const [file] = e.target.files;
      this.file = file;
      const $this = this;

      var reader = new FileReader();
      reader.onloadend = function () {
        $this.compressImage(this.result);
        // $this.pekerjaan.gambar = this.result;
      };
      reader.readAsDataURL(file);
    },
    edit(item) {
      setTimeout(() => {
        this.pekerjaanDetail = item;
        this.addProgress = true;
        this.editing = true;
      }, 150);
    },
    simpanPekerjaan() {
      this.loadingSimpan = true;
      setTimeout(() => {
        const data = new FormData();
        if (this.pekerjaan.id) {
          data.append("id", this.pekerjaan.id);
        }
        data.append("id_user", this.pekerjaan.id_user);
        data.append("nama", this.pekerjaan.nama);
        data.append("keterangan", this.pekerjaan.keterangan);

        data.append(
          "tgl_target",
          moment(this.pekerjaan.tgl_target).format("YYYY-MM-DD")
        );
        data.append("status", this.pekerjaan.status);

        if (this.file) {
          data.append("gambar", this.file);
        }
        if (this.pekerjaan.gambarBase64) {
          data.append("gambar_base64", this.pekerjaan.gambarBase64);
        }

        const config = {
          onUploadProgress: function (progressEvent) {
            let percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        };

        const self = this;
        axios
          .post(
            "https://api.pspp-integrated.com/api/v1/kendali_kerja/pekerjaanController/save",
            data,
            config
          )
          .then((res) => {
            this.loadingSimpan = false;
            self.$router.go(-1);
          })
          .catch(function (err) {
            console.log(err.message);
          });

        // api
        //   .post("/v1/kendali_kerja/pekerjaanController/save", this.pekerjaan)
        //   .then(() => {
        //   });
      }, 150);
    },
    openCamera() {
      setTimeout(() => {
        navigator.device.capture.captureImage(
          (mediaFiles) => {
            var image = mediaFiles[0];

            this.loadingGambar = true;
            this.displayImage(image.fullPath);
          },
          function (error) {
            alert("Error capturing image: " + error);
          },
          { limit: 1 }
        );
      }, 150);
    },

    compressImage(imageUrl) {
      const $this = this;
      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        // Atur ukuran canvas sesuai kebutuhan
        var maxWidth = 900;
        var maxHeight = 1300;
        var width = img.width;
        var height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        // Menggambar gambar di canvas dengan ukuran yang disesuaikan
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        var compressedImageUrl = canvas.toDataURL("image/jpeg", 0.75);

        $this.pekerjaan.gambar = compressedImageUrl;
        $this.pekerjaan.gambarBase64 = compressedImageUrl;
        $this.loadingGambar = false;
      };

      img.src = imageUrl;
    },

    displayImage(imageUrl) {
      const $this = this;
      window.resolveLocalFileSystemURL(
        imageUrl,
        (fileEntry) => {
          fileEntry.file(
            (file) => {
              var reader = new FileReader();
              reader.onloadend = function () {
                $this.compressImage(this.result);
              };
              reader.readAsDataURL(file);
            },
            (error) => {
              console.log("Error reading file:", error);
            }
          );
        },
        (error) => {
          console.log("Error accessing file:", error);
        }
      );
    },

    hideForm() {
      setTimeout(() => {
        this.addProgress = false;
        this.editing = false;
      }, 150);
    },
    updateProgress() {
      this.loadingDetail = true;
      setTimeout(() => {
        this.pekerjaanDetail.id_pekerjaan = this.pekerjaan.id;
        api
          .post(
            "/v1/kendali_kerja/pekerjaanController/updateProgress",
            this.pekerjaanDetail
          )
          .then((r) => {
            this.loadingDetail = false;
            if (r.valid) {
              this.progress = r.data;
              this.pekerjaanDetail = {};
              this.addProgress = false;
              this.editing = false;
            }
          });
      }, 150);
    },
  },
  mounted() {
    this.user = this.$store.state.user.data;
    this.pekerjaan.id_user = this.$user.id;

    if (this.$route.params.id > 0) {
      this.loadData(this.$route.params.id);
    }
  },
};
</script>

<style scoped lang="scss">
.form {
  .header {
    position: fixed;
    top: 0;
    left: calc(50% - 240px);
    width: 440px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #ccc;
    padding: 15px 20px;
    background: #fff;
    z-index: 9;

    @media screen and (max-width: 768px) {
      left: 0;
      width: calc(100% - 40px);
    }

    h3 {
      margin: 0;
    }
    .icon {
      display: flex;
      align-items: center;
      height: 26px;
      transition: transform 0.2s ease;
      &:active {
        transform: scale(1.5);
      }
    }
  }
  .nav-top {
    background: #fff;
    box-shadow: 0px 2px 3px #ccc;
    display: grid;
    grid-template-columns: 1fr 50px;
    margin-bottom: 2px;
    .title {
      font-size: 14px;
      font-weight: bold;
      padding: 15px;
    }
    .save {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #009be7;
      color: #fff;
      &:active {
        background: #0087ca;
      }
    }
  }

  .body {
    padding: 60px 4px 60px;
    .card {
      background: #fff;
      padding: 15px 15px 25px 15px;

      p {
        margin: 0;
      }
    }

    .form-group {
      &:last-child {
        margin-bottom: 0;
      }
    }

    p.card-title {
      margin: 0;
      color: var(--primary);
      font-weight: 500;
      margin-bottom: 10px;
    }
    .progress {
      padding: 0 18px 80px;
      p:first-child {
        margin: 0;
        font-weight: 500;
        font-size: 14px;
        color: var(--primary);
      }

      .progress-list {
        ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
          li {
            padding: 10px 0;
            border-bottom: 1px solid #ccc;
            &:active {
              background: #f8f8f8;
            }
            small {
              font-size: 12px;
              font-weight: bold;
            }
            p {
              margin: 0;
              font-size: 14px;
              font-weight: normal;
              color: #777;
            }
          }
        }
      }
      .progress-form {
        background: #fff;
        margin-top: 15px;
        position: relative;
        .close {
          font-size: 24px;
          position: absolute;
          right: 15px;
          top: 15px;
          display: block;
          padding: 0px 5px;
          &:active {
            background: #eee;
          }
        }
      }
      .btn-progress {
        background: none;
        border: 1px solid var(--primary);
        border-radius: 4px;
        color: var(--primary);
        padding: 10px;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        display: block;
        margin: 15px auto;
        width: 200px;
        &:active {
          background: #eee;
        }
      }
    }
  }

  .btn-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;

    .btn-progress {
      width: 100% !important;
    }
    .btn-batal {
      color: #d64948 !important;
      border: 1px solid #d64948 !important;
    }
  }

  .gallery,
  .camera {
    border: 1px solid #ddd;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #777;
    padding: 15px;
    font-size: 14px;
    &:active {
      background: #eee;
    }
  }

  .gallery {
    position: relative;
    input {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: calc(100% - 20px) !important;
    }
  }
}

.skeleton-wrapper {
  padding: 20px;
  .input {
    min-height: 45px;
    border-radius: 4px;
    margin-bottom: 25px;
  }
  .textarea {
    min-height: 140px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
  .label {
    min-height: 20px;
    border-radius: 4px;
    margin-bottom: 6px;
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  display: flex;
  justify-content: center;
  .modal-body {
    border-radius: 5px;
    margin: 30px;
    background: #fff;
    padding: 15px;
    margin-top: 80px;
    height: 400px;
    width: 300px;
  }

  .camera {
    position: relative;
    padding: 0;
    #video,
    #photo {
      width: 100%;
      height: 400px;
      object-fit: contain;
    }
    .camera-controller {
      position: absolute;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 70px;
      margin-top: -6px;
      display: flex;
      justify-content: center;
      align-items: center;
      &.ok {
        height: 55px;
        justify-content: space-between;
        button {
          background-color: #fff;
          border: 0;
          outline: none;
          padding: 10px 15px;
          border-radius: 4px;
          text-transform: uppercase;
          transition: all 0.3s ease;
          width: 80px;
          &:active {
            transform: scale(0.9);
          }
          &:first-child {
            margin-left: 10px;
          }
          &:last-child {
            margin-right: 10px;
          }
        }
      }
    }
    .btn-photo {
      width: 55px;
      height: 55px;
      border-radius: 70px;
      border: 0;
      background-color: #fff;
      transition: all 0.3s ease;
      &:active {
        width: 50px;
        height: 50px;
      }
    }
  }
}

#canvas {
  display: none;
}

.overlay-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
.tgl-target {
  input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue